export default __webpack_public_path__ + "static/media/Screenshot 2022-11-02 at 19.14.13.8efc5966.png";